import React from 'react';
import '../styles/splashScreen.css';

function SplashScreen() {
  return (
    <div className="splash-screen">
      <div className="loading-animation">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
}

export default SplashScreen;